const intFormat = new Intl.NumberFormat("mn-MN")

/** 24.8 сая ₮, 159 мянга ₮, 512 ₮ — compact MNT, number first (canvas Ord_Dashboard) */
export function formatCompactMnt(value: number): { display: string; unit: string } {
  const abs = Math.abs(value)
  if (abs >= 1_000_000_000) return { display: (value / 1_000_000_000).toFixed(2), unit: "тэрбум ₮" }
  if (abs >= 1_000_000)     return { display: (value / 1_000_000).toFixed(2),     unit: "сая ₮" }
  if (abs >= 1_000)         return { display: (value / 1_000).toFixed(0),         unit: "мянга ₮" }
  return { display: intFormat.format(Math.round(value)), unit: "₮" }
}

/** One-string form of formatCompactMnt for table cells: "24.80 сая ₮" */
export function formatMnt(value: number): string {
  const f = formatCompactMnt(value)
  return `${f.display} ${f.unit}`
}

/** Chart axis label: "75 сая", "500 мянга" */
export function formatAxisMnt(value: number): string {
  const abs = Math.abs(value)
  if (abs >= 1_000_000_000) return `${+(value / 1_000_000_000).toFixed(1)} тэрбум`
  if (abs >= 1_000_000)     return `${+(value / 1_000_000).toFixed(1)} сая`
  if (abs >= 1_000)         return `${+(value / 1_000).toFixed(0)} мянга`
  return String(Math.round(value))
}

export function formatInt(value: number): string {
  return intFormat.format(Math.round(value))
}

export function formatDecimal(value: number, fractionDigits = 1): string {
  return value.toFixed(fractionDigits)
}

/** Returns "12.3%" with sign up/down/flat, or "—"; the caller draws the arrow. */
export function formatPct(pct: number | null): { sign: "up" | "down" | "flat"; text: string } {
  if (pct === null) return { sign: "flat", text: "—" }
  if (pct === 0) return { sign: "flat", text: "0%" }
  if (pct > 0) return { sign: "up", text: `${pct.toFixed(1)}%` }
  return { sign: "down", text: `${Math.abs(pct).toFixed(1)}%` }
}

/** Absolute delta; the caller draws the arrow */
export function formatDelta(delta: number | null, fractionDigits = 1): { sign: "up" | "down" | "flat"; text: string } {
  if (delta === null) return { sign: "flat", text: "—" }
  if (delta === 0) return { sign: "flat", text: "0" }
  if (delta > 0) return { sign: "up", text: delta.toFixed(fractionDigits) }
  return { sign: "down", text: Math.abs(delta).toFixed(fractionDigits) }
}

/** "MM-DD" from ISO date string */
export function formatMonthDay(iso: string): string {
  const d = new Date(iso)
  const m = String(d.getMonth() + 1).padStart(2, "0")
  const day = String(d.getDate()).padStart(2, "0")
  return `${m}-${day}`
}
